var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08301 2.08331C3.87387 2.08331 2.08301 3.87418 2.08301 6.08332V18.9166C2.08301 21.1258 3.87387 22.9166 6.08301 22.9166H12.3755V15.7893H9.91217V13.0117H12.3755V10.9634C12.3755 8.58612 13.8662 7.29165 16.0444 7.29165C17.0879 7.29165 17.9841 7.36757 18.2455 7.40131V9.88597L16.7351 9.88674C15.5507 9.88674 15.3215 10.4351 15.3215 11.2387V13.0125H18.1463L17.7785 15.7901H15.3215V22.9166H18.9163C21.1255 22.9166 22.9163 21.1258 22.9163 18.9166V6.08331C22.9163 3.87417 21.1255 2.08331 18.9163 2.08331H6.08301Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c19c6e25d858f2968c868ef44eefd480.svg";
export { ForwardRef as ReactComponent };